import React, { ReactNode } from "react";
import { HStack, Progress, StackProps, chakra } from "@chakra-ui/react";
import { useTween } from "react-use";

type CertificationProgressProps = {
  isShort?: boolean;
  isAnimated?: boolean;
  children?: ReactNode;
  animationDuration?: number;
  animationDelay?: number;
  completed: number;
  total: number;
} & StackProps;

export default function CertificationProgress({
  isShort,
  isAnimated,
  animationDuration,
  animationDelay,
  completed,
  total,
  children,
  ...props
}: CertificationProgressProps) {
  // used for animating the progress fill
  const t = useTween("outQuad", animationDuration, animationDelay);
  const offset = isAnimated ? 1 - t : 0;
  return (
    <HStack spacing="3" {...props}>
      <chakra.span
        flexShrink={0}
        fontFamily="mono"
        fontSize="sm"
        fontWeight="semibold"
        textTransform="uppercase"
      >
        {completed}/{total}
        {!isShort && " courses"}
      </chakra.span>
      <Progress
        size="xs"
        colorScheme="indigo"
        w="full"
        max={1}
        value={(completed - offset) / total}
        rounded="full"
        aria-label="Courses completed"
      />
      {children}
    </HStack>
  );
}
